import {
  GetCountryLanguagesResp,
  GetLanguagesResp,
  LanguageDto,
  LanguageModel,
} from '../types/language'

export const transformLanguageDto = (
  language: LanguageDto,
  isoLocaleCode: string,
): LanguageModel => {
  const { id, title, code, title_local, title_short, current } = language

  return {
    id,
    title,
    code,
    current,
    titleLocal: title_local,
    titleShort: title_short,
    isoLocaleCode,
  }
}

export const transformLanguageResponse = ({
  languages,
  country,
}: GetLanguagesResp): Array<LanguageModel> =>
  languages.map(dto => ({
    ...transformLanguageDto(dto, `${dto.code}-${country.iso_code}`),
  }))

export const transformCountryLanguageResponse = ({
  languages,
  country,
  primary_language,
}: GetCountryLanguagesResp): {
  countryLanguages: Array<LanguageModel>
  primaryCountryLanguage: LanguageDto | null
} => ({
  countryLanguages: transformLanguageResponse({ languages, country }),
  primaryCountryLanguage: primary_language,
})
